<!-- <template>
  <div class="build">
    <control />
  </div>
</template>

<script>
import Control from "@/components/Control";

export default {
  components: {
    Control,
  },
};
</script>
<style lang="scss" scoped>
.build {
  height: 100vh;
  background: #f7f8fa;
  }
</style> -->


<template>
  <div class="build">
    <control v-if="dataLoaded" />
    <div v-else class="loading-container">
      <!-- We will use Loading service instead of el-loading component -->
    </div>
  </div>
</template>

<script>
import Control from "@/components/Control";
import { getProjectById } from "@/api/project";
import { mapGetters, mapMutations } from "vuex";
// Import Loading service from Element UI
import { Loading } from "element-ui";

export default {
  components: {
    Control,
  },
  data() {
    return {
      dataLoaded: false,
      loadingInstance: null
    };
  },
  computed: {
    ...mapGetters(["project", "curPage"]),
  },
  methods: {
    ...mapMutations(["setProject", "setCurPage"]),
    
    async fetchLatestData() {
      try {
        // 先从 Vuex 获取当前页面 ID
        const pageId = this.curPage?.id;
        // 获取项目 ID
        const projectId = this.project?._id;

        if (!projectId) {
          console.error("项目ID不存在，无法获取数据");
          this.dataLoaded = true;
          return;
        }

        // 从服务器获取最新项目数据
        const { data } = await getProjectById({ id: projectId });

        if (data && data.pages) {
          // 更新整个项目数据到 Vuex
          this.setProject(data);
          
          // 根据页面 ID 找到对应的页面
          const currentPage = data.pages.find(page => page.id === pageId);
          
          if (currentPage) {
            // 更新当前页面到 Vuex
            this.setCurPage(currentPage);
          } else {
            console.error("无法找到当前页面，使用项目首页");
            // 找不到页面时使用首页
            const homePage = data.pages.find(page => page.home);
            if (homePage) {
              this.setCurPage(homePage);
            }
          }
        }
      } catch (error) {
        console.error("获取最新数据失败:", error);
        this.$message.error("获取最新数据失败，将使用本地缓存的数据");
      } finally {
        this.dataLoaded = true;
        // 关闭加载中动画
        if (this.loadingInstance) {
          this.loadingInstance.close();
        }
      }
    }
  },
  created() {
    // 组件创建时就开始获取最新数据
    this.fetchLatestData();
  },
  mounted() {
    // 使用 Loading 服务创建全屏加载
    this.loadingInstance = Loading.service({
      fullscreen: true,
      text: "正在获取最新数据...",
      background: "rgba(255, 255, 255, 0.7)"
    });
  },
  beforeDestroy() {
    // 组件销毁前关闭 loading
    if (this.loadingInstance) {
      this.loadingInstance.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.build {
  height: 100vh;
  background: #f7f8fa;
}
.loading-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>